<template>
    <div v-if="disabledMaintenance">
        <span style="color: rgb(246, 139, 57); font-size: 18px; padding-left: 6rem;">We are under maintenance from
            22<sup>nd</sup> Jan. 2023 13:00 to 16:00 (GMT+8) Sorry for your inconvience.</span><br />
    </div>
    <div class="container">
        <!-- <the-header></the-header> -->
        <div class="search_bar">
            <div class="flex align-items-center justify-content-right font-black text-black border-round">
                <InputText v-model="inputCode" type="text" @keypress.enter="getTrackingCode" />
                <div class="track-btn flex align-items-center justify-content-right w-8rem h-3rem">
                    <base-button label="Track" @click="getTrackingCode" />
                </div>
            </div>

            <p class="err-msg" v-if="isError">
                Tracking number requires at least 3 characters
            </p>
        </div>

        <p class="search-result">
            Search result for:
            <span class="search-digits">{{ inputCode }}</span>
        </p>
        <div class="NoTrackingDataView" v-if="!dataList || dataList.length === 0">
            <div>
                <img src="../../assets/No_TrackAndTrace.svg" />
            </div>
            <h3>No matching result. Please try again!</h3>
        </div>
        <ul v-else>
            <shipment-item v-for="trackItem in dataList" :key="trackItem.houseNo" :trackItem="trackItem"></shipment-item>
            <the-pagination :current-page="pageIndex" :page-size="pageSize" :total-items="totalItems"
                :currentItems="currentItems" @onChangePage="onChangePage" style="margin: 0 auto" />
        </ul>
        <loading loader="Spinner" v-model:active="isLoading" :can-cancel="false" :is-full-page="true">
            <div class="loading-spinner">
                <div class="loading-section">
                    <div></div>
                </div>
            </div>
        </loading>
    </div>
</template>

<script>
import ShipmentItem from "../shipment/ShipmentItem.vue";
import json from "../../assets/data/dummydata.json";
import ProductService from "../../Service/ProductService";
import ThePagination from "../layouts/ThePagination.vue";
import iconBookVue from '../icons/icon-book.vue';
import iconDone from '../icons/icon-done.vue';
import moment from 'moment-timezone'
export default {
    components: { ShipmentItem, ThePagination },
    props: {
        code: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            myJson: json,
            dataList: [],
            isLoading: false,
            pageIndex: 1,
            pageSize: null,
            totalItems: null,
            trackingNo: null,
            currentItems: 1,
            inputCode: "",
            isError: false,
            disabledMaintenance: false,

        };
    },
    created() {
        this.productService = new ProductService();
        this.inputCode = this.$route.query.KeyValue;
        if (this.$route?.query?.KeyValue?.length < 3) {
            this.isError = true;
            return;
        }
        this.getList(this.inputCode, this.pageIndex);
        const currentDate = moment.tz('Asia/Taipei').unix();
        const DueDate = moment.utc('2023-01-22T07:00:00.000').unix();
        if (DueDate > currentDate) {
            this.disabledMaintenance = true;
        }
    },

    mounted() {
        this.dataList = [];
        if (this.trackingNo != '' && this.trackingNo != null) {
            this.getTrackingCode();
        }
        this.showMaintenanceAnnouncement();
    },

        methods: {
            getTrackingCode() {
                if (!this.validateSearch()) {
                    this.isError = true;
                    return;
                } else {
                    //need to encoding for Special characters
                    const keyvalue = encodeURIComponent(this.inputCode);
                    this.getList(keyvalue, 1);
                    this.currentItems = 1;
                    this.isError = false;
                    this.$router.push(`/TrackAndTrace?KeyValue=${this.inputCode}`);
                    //this.$router.push("/");
                }                
            },
            validateSearch() {
                return this.inputCode.length < 3 ? false : true
            },
            onChangePage(page) {
                this.getList(this.inputCode, page);
                this.pageIndex = page;
                this.currentItems = (page - 1) * 5;
            },
            getList(searchValue, pageIndex) {
                this.isLoading = true;
                this.productService
                    .getTrackAndTraceList(searchValue, pageIndex)
                    .then((res) => {
                        if (res.pageInfo.totalCount == 1) {
                            const params = res.result[0].houseNo;
                            //Change symbol(/) to %2F by Ziv at 2023/3/30 VAL-11686
                            //this.$router.push(`/TrackAndTrace/detail/${params}?cache=no`);
                            const _inputCode = params.toString().replaceAll("/", "%2F");
                            this.$router.push(`/TrackAndTrace/detail/${_inputCode}?cache=no`);
                        } else {
                            this.pageIndex = res.pageInfo.page;
                            this.pageSize = res.pageInfo.pageSize;
                            this.totalItems = res.pageInfo.totalCount;

                        let data = res.result;                        
                        data.map((e) => {
                            e.poNo = e?.poNo?.replaceAll(",", " ");

                            if (e.totalPercentage > 0) {
                                e.mileStones[0].active = true;
                            }
                            if (e.totalPercentage >= 25) {
                                e.mileStones[1].active = true;
                            }
                            if (e.totalPercentage >= 50) {
                                e.mileStones[2].active = true;
                            }
                            if (e.totalPercentage >= 75) {
                                e.mileStones[3].active = true;
                            }
                            if (e.totalPercentage === 100) {
                                e.mileStones[4].active = true;
                            }
                            if (e?.mileStones && e?.mileStones.length > 0) {
                                e.mileStones[0].icon = iconBookVue;
                                e.mileStones[4].icon = iconDone;

                                if (e.shipmentType === "AIR") {
                                    e.mileStones[1].icon = "icon-package";
                                    e.mileStones[2].icon = "icon-plane-fly";
                                    e.mileStones[3].icon = "icon-plane-land";
                                }
                                if (e.shipmentType === "FCL" || e.shipmentType === "LCL") {
                                    e.mileStones[1].icon = "icon-load";
                                    e.mileStones[2].icon = "icon-ship";
                                    e.mileStones[3].icon = "icon-ship";
                                }
                                if (e.shipmentType === "TRUCK") {
                                    e.mileStones[1].icon = "icon-package";
                                    e.mileStones[2].icon = "icon-truck";
                                    e.mileStones[3].icon = "icon-truck";
                                }
                                if (e.shipmentType === "RAILWAY") {
                                    e.mileStones[1].icon = "icon-load";
                                    e.mileStones[2].icon = "icon-rail";
                                    e.mileStones[3].icon = "icon-rail";
                                }
                                if (e.shipmentType === "Domestic") {
                                    e.mileStones[1].icon = "icon-package";
                                    e.mileStones[2].icon = "icon-plane-fly";
                                    e.mileStones[3].icon = "icon-plane-land";
                                }
                            }
                        });
                            console.log(data);
                        this.dataList = data;

                        this.isLoading = false;
                    }
                });
        },
        showMaintenanceAnnouncement() {

        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.container {
    padding-bottom: 5rem;
    background: #f5f5f5;
}

.search-result {
    font-size: 1.4rem;
    color: #8b95a0;
    padding: 2rem 5rem;
}

.search-digits {
    font-size: 1.4rem;
    line-height: 1.9rem;
    color: #011837;
}

ul {
    list-style: none;
    padding: 0 5rem;
    display: flex;
    flex-direction: column;
}

.NoTrackingDataView {
    font-size: 16px;
    text-align: center;
    padding-top: 14rem;
    padding-bottom: 14rem;
}

.search_bar {
    display: flex;
    flex-direction: column;
    background-color: #e7eef1;
    justify-content: center;
    align-items: flex-start;
    padding: 3rem 0 3rem 5rem;
    gap: 1rem;
}

.p-inputtext {
    width: 20rem;
    height: 4rem;
    font-size: 1.4rem;
    padding-left: 10px;
}

.track-btn {
    margin-left: 1rem;
}

.err-msg {
    color: #ff0033;
    font-size: 1.2rem;
}

h3 {
    font-size: 1.6rem;
    line-height: 2.2;
    color: #465363;
    font-family: MyDimerco-OpenSansBold;
}

@keyframes loading-section {
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}

.loading-section div {
    position: absolute;
    width: 126px;
    height: 126px;
    border: 10px solid #0a69aa;
    border-top-color: transparent;
    border-radius: 50%;
}

.loading-section div {
    animation: loading-section 1s linear infinite;
    top: 100px;
    left: 100px;
}

.loading-spinner {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    background: transparent;
}

.loading-section {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0;
    /* see note above */
}

.loading-section div {
    box-sizing: content-box;
}

@media screen and (max-width: 1366px) {
    .NoTrackingDataView h3 {
        font-size: 14px;
    }
}
</style>
